import { VehOrigen } from "./VehOrigen";

export class DestinoTransportistas {
    public id: string;
    public origen: string;
    public destinoCode: string;
    public codTransp: string;

    public fecCreacion: Date = new Date();
    public usrCreacion: string;
    public fecModif: Date | undefined;
    public usrModif: string | undefined;
    public estado: boolean;

    public origenField: string = "";
    public transporteField: string = "";
    public destinoField: string = "";
    public isAdd: boolean;
    public isSave: boolean;
    public isEdit: boolean;
    public originalData: DestinoTransportistas;

    static transformDestinoTransportistas(data: any): DestinoTransportistas{
        let destinoTransportistas = new DestinoTransportistas;
        destinoTransportistas.id = data.id;
        destinoTransportistas.origen = data.origen;
        destinoTransportistas.destinoCode = data.destinoCode;
        destinoTransportistas.codTransp = data.codTransp;

        destinoTransportistas.estado = data.estado;
        destinoTransportistas.usrCreacion = data.usrCreacion;
        destinoTransportistas.fecCreacion = new Date(data.fecCreacion);

        if (data.usrModif != undefined) {
          destinoTransportistas.usrModif = data.usrModif;
          destinoTransportistas.fecModif = new Date(data.fecModif);
        }

        return destinoTransportistas;
      }

      public changeOrigen(noDescOrigen: string) {
        this.origen = noDescOrigen;
      }

      public changeDestino(noDescDestino: string) {
        this.destinoCode = noDescDestino;
      }

      public changeTransporte(noDescTransporte: string) {
        this.codTransp = noDescTransporte;
      }
}
